import React, { FunctionComponent, useState } from 'react';

import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { VoBScoring } from 'common/response-editor/vob/VobScoring';

import 'common/response-editor/warning-message/WarningMessage.scss';

type WarningMessageProps = {
    meetsThreshold?: boolean;
    onDecision: (publish: boolean) => void;
};

export const WarningMessage: FunctionComponent<WarningMessageProps> = ({ meetsThreshold, onDecision }) => {
    const { t } = useTranslation(['common/response-editor']);
    const [disable, setDisable] = useState(false);

    const message = (
        <>
            {t(`${meetsThreshold !== undefined ? 'WARNING_CONTENT_PRE_ANALYZED' : 'WARNING_CONTENT_PRE_NOT_ANALYZED'}`)}{' '}
            {t('WARNING_CONTENT_POST')}
        </>
    );

    const handleDecision = (publish: boolean) => {
        if (publish) {
            setDisable(true);
        }

        onDecision(publish);
    };

    return (
        <div className="warning-bounds-container">
            <div className="warning-title">{t('WARNING_TITLE')}</div>
            <div className="vob-scoring">
                <span>{message}</span>
                <VoBScoring meetsThreshold={meetsThreshold} isWarningMessage />
            </div>
            <div className="warning-buttons">
                <Button
                    className="btn-tool-bar-generate"
                    variant="outline-primary"
                    onClick={() => handleDecision(false)}
                    disabled={disable}
                >
                    {t('CONTINUE_EDITING')}
                </Button>
                <Button className="btn btn-danger" variant="" onClick={() => handleDecision(true)} disabled={disable}>
                    {t('PUBLISH_ANYWAY')}
                </Button>
            </div>
        </div>
    );
};
